export { default } from './solva-bank';
